// src/components/AppSnackbarProvider.jsx

import React from "react";
import { SnackbarProvider } from "notistack";
import { alpha, useTheme } from "@mui/material";

export default function AppSnackbarProvider({ children }) {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  return (
    <SnackbarProvider
      maxSnack={4}
      autoHideDuration={3200}
      preventDuplicate
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      style={{
        borderRadius: 16,
        fontWeight: 800,
        backdropFilter: "blur(14px)",
        background: isDark ? alpha("#0f172a", 0.96) : alpha("#ffffff", 0.96),
        color: theme.palette.text.primary,
        boxShadow: isDark
          ? "0 18px 50px rgba(0,0,0,0.45)"
          : "0 18px 50px rgba(15,23,42,0.16)",
      }}
    >
      {children}
    </SnackbarProvider>
  );
}